/**
 * Mirrors five-bag-rule-app/src/rule-engine.js — validates live /cart.js at checkout click.
 * No external requests except same-origin /cart.js.
 */
(function () {
  var cfg = typeof window !== 'undefined' ? window.fiveBagRuleLocalConfig : null;
  if (!cfg) return;

  var RULE = {
    requiredMultiple: 5,
    weightTriggerGrams: 1500,
    eligibleTagValues: ['five-bag-rule', 'five_bag_rule', '1-5kg'],
    optionContains: ['1.5kg'],
    titleContains: ['1.5kg'],
    metafieldKeys: ['five_bag_rule', 'five_bag_only']
  };

  function normalize(value) {
    return String(value ?? '').trim().toLowerCase();
  }

  function metafieldTruthy(metafields, keys) {
    metafields = metafields || {};
    keys = keys || [];
    for (var i = 0; i < keys.length; i++) {
      var raw = metafields[keys[i]];
      if (raw === true || normalize(raw) === 'true') return true;
    }
    return false;
  }

  function lineMatchesRule(line) {
    var title = normalize(line.productTitle);
    var variantTitle = normalize(line.variantTitle);

    if (metafieldTruthy(line.productMetafields, RULE.metafieldKeys)) return true;
    if (metafieldTruthy(line.variantMetafields, RULE.metafieldKeys)) return true;

    if (Number(line.variantGrams) === Number(RULE.weightTriggerGrams)) return true;

    for (var ti = 0; ti < RULE.titleContains.length; ti++) {
      var s = normalize(RULE.titleContains[ti]);
      if (title.indexOf(s) !== -1 || variantTitle.indexOf(s) !== -1) return true;
    }

    var opts = line.optionValues || [];
    for (var oi = 0; oi < opts.length; oi++) {
      var ov = normalize(opts[oi]);
      for (var ci = 0; ci < RULE.optionContains.length; ci++) {
        if (ov.indexOf(normalize(RULE.optionContains[ci])) !== -1) return true;
      }
    }

    var tags = (line.productTags || []).map(normalize);
    for (var gi = 0; gi < tags.length; gi++) {
      if (RULE.eligibleTagValues.indexOf(tags[gi]) !== -1) return true;
    }

    return false;
  }

  function evaluateFiveBagRule(lines) {
    var qualifying = [];
    for (var i = 0; i < lines.length; i++) {
      if (lineMatchesRule(lines[i])) qualifying.push(lines[i]);
    }
    var totalBags = 0;
    for (var j = 0; j < qualifying.length; j++) {
      totalBags += Number(qualifying[j].quantity || 0);
    }
    var remainder = totalBags % RULE.requiredMultiple;
    return {
      valid: remainder === 0,
      totalBags: totalBags,
      requiredMultiple: RULE.requiredMultiple,
      remainder: remainder
    };
  }

  function getAugment() {
    var el = document.getElementById('five-bag-rule-augment-data');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function buildLines(cart) {
    var augment = getAugment();
    return (cart.items || []).map(function (item) {
      var optionValues = [];
      if (item.options_with_values && item.options_with_values.length) {
        item.options_with_values.forEach(function (o) {
          optionValues.push(o.value);
        });
      }
      var extra = augment[item.key] || {};
      return {
        quantity: item.quantity,
        variantGrams: item.grams || 0,
        variantTitle: item.variant_title || '',
        productTitle: item.product_title || '',
        optionValues: optionValues,
        productTags: extra.productTags || [],
        productMetafields: extra.productMetafields || {},
        variantMetafields: extra.variantMetafields || {}
      };
    });
  }

  function validateCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        return evaluateFiveBagRule(buildLines(cart));
      });
  }

  function resumeCheckout(btn) {
    var form = btn.form ? btn.form : document.getElementById(btn.getAttribute('form') || '');
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
      return;
    }
    if (form) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = btn.name;
      if (btn.value) h.value = btn.value;
      form.appendChild(h);
      form.submit();
      return;
    }
    window.location.href = '/checkout';
  }

  var bypass = false;
  var busy = false;

  document.addEventListener(
    'click',
    function (e) {
      if (bypass) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      if (busy) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      busy = true;
      btn.setAttribute('aria-busy', 'true');

      validateCart()
        .then(function (result) {
          if (result.valid) {
            bypass = true;
            resumeCheckout(btn);
            setTimeout(function () {
              bypass = false;
            }, 0);
          } else {
            window.alert(cfg.blockMessage || '1.5kg bags must be ordered in multiples of five.');
          }
        })
        .catch(function () {
          window.alert(
            cfg.cartErrorMessage ||
              'We could not load your cart. Please refresh the page and try again.'
          );
        })
        .finally(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
        });
    },
    true
  );
})();
